import CommandeForm from "./CommandeForm";
import "./CommandeModal.css"
import { PanierElement } from "../PanierContext";

interface CommandeModalProps {
    isOpen: boolean;
    onClose: () => void;
    saveUserId: (customerId:string) => void;
    customerId: string;
    saveOrderId: (orderId:string) => void;
    orderId: string;
    panier: PanierElement[];
}

export default function CommandeModal({ isOpen, onClose, saveUserId, customerId, saveOrderId, orderId, panier }: CommandeModalProps) {
    if (!isOpen) return null;

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <button className="close-button" onClick={onClose}>✖</button>
                <CommandeForm saveUserId={(newId) => saveUserId(newId)} customerId={customerId} saveOrderId={(newId) => saveOrderId(newId)} orderId={orderId} panier={panier} />
            </div>
        </div>
    );
}
